import { Empty } from 'antd';

const style = {
	display: 'flex',
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%'
}

const DefaultEmptyRowsRenderer = () =>{
	return (
		<div style={style}>
			<Empty description={false} />			
		</div>
	)
}

export default DefaultEmptyRowsRenderer;
